/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisciplineGroup,
    DisciplineGroupFromJSON,
    DisciplineGroupFromJSONTyped,
    DisciplineGroupToJSON,
} from './DisciplineGroup';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';

/**
 * 
 * @export
 * @interface DisciplineSubgroup
 */
export interface DisciplineSubgroup {
    /**
     * 
     * @type {string}
     * @memberof DisciplineSubgroup
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof DisciplineSubgroup
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DisciplineSubgroup
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DisciplineSubgroup
     */
    name?: string | null;
    /**
     * 
     * @type {Array<Subject>}
     * @memberof DisciplineSubgroup
     */
    subjects?: Array<Subject> | null;
    /**
     * 
     * @type {string}
     * @memberof DisciplineSubgroup
     */
    groupId?: string;
    /**
     * 
     * @type {DisciplineGroup}
     * @memberof DisciplineSubgroup
     */
    group?: DisciplineGroup;
}

export function DisciplineSubgroupFromJSON(json: any): DisciplineSubgroup {
    return DisciplineSubgroupFromJSONTyped(json, false);
}

export function DisciplineSubgroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisciplineSubgroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectFromJSON)),
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'group': !exists(json, 'group') ? undefined : DisciplineGroupFromJSON(json['group']),
    };
}

export function DisciplineSubgroupToJSON(value?: DisciplineSubgroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'name': value.name,
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectToJSON)),
        'groupId': value.groupId,
        'group': DisciplineGroupToJSON(value.group),
    };
}

